import React from "react";
import { default as WFormControl } from "@mui/material/FormControl";

function FormControl(props) {
  return <WFormControl {...props} />;
}

export default FormControl;
